import { translations } from '../i18n/translations';

export default function getTranslationsByLangOrEng(lang: string, key: string) {
  return lang in translations && translations[lang][key]
    ? translations[lang][key]
    : translations.en[key];
}
